var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperCheckIcon = function SvgPaperCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBA34",
    fillRule: "evenodd",
    d: "M8 8.799 0 3.464V2.002C0 .896.896 0 2 0h12a2 2 0 0 1 2 2v1.466L8 8.797zM8 11.2l8-5.333V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.87z"
  })));
};
export default SvgPaperCheckIcon;